import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components/macro'
import { Spin } from 'antd'

export const centerChildrenMixin = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

const loadingMixin = css`
  top: 0;
  left: 0;
  z-index: 10000;
  background-color: #000;
  opacity: 0.5;
  background-color: ${({ theme }) => theme.colors.white};
  ${centerChildrenMixin}
`

export const PageLoadingWrapper = styled.div`
  && {
    width: 100vw;
    height: 100vh;
    position: fixed;
    ${loadingMixin}
  }
`

export const ExtraLargeSpin = styled(Spin)`
  &.ant-spin {
    .ant-spin-dot {
      font-size: 50px;
      i {
        width: 25px;
        height: 25px;
        background-color: ${({ theme }) => theme.colors.main};
      }
    }
  }
`

export const LoadingOverlay = ({
  loading,
  children,
  overlayColor
}: {
  loading: boolean
  overlayColor?: string
  children: ReactNode | ReactNode[]
}) => {
  return (
    <>
      {loading && (
        <PageLoadingWrapper color={overlayColor}>
          <ExtraLargeSpin delay={150} />
        </PageLoadingWrapper>
      )}
      {children}
    </>
  )
}
